/** Variables de entorno tipadas. */
export const env = {
  apiUrl:             import.meta.env.VITE_URL                as string,
  apiService:         import.meta.env.VITE_SERVICE            as string,
  nocoToken:          import.meta.env.VITE_NOCO_TOKEN         as string,
  enableConfig:       import.meta.env.VITE_ENABLE_CONFIG === 'true',
  blinkidApikey:      import.meta.env.VITE_BLINKID_APIKEY     as string,
  credentialsApikey:  import.meta.env.VITE_CREDENTIALS_APIKEY as string,
} as const;
